import { render, staticRenderFns } from "./MailPopupRappel.vue?vue&type=template&id=2651270e"
import script from "./MailPopupRappel.vue?vue&type=script&lang=ts"
export * from "./MailPopupRappel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports